import isPropValid from '@emotion/is-prop-valid';
import React from 'react';
import { StyleSheetManager } from 'styled-components';

const SafeStyleSheetManager: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <StyleSheetManager
    shouldForwardProp={(propName, element) =>
      typeof element === 'string' ? isPropValid(propName) : true
    }
  >
    {children}
  </StyleSheetManager>
);

export default SafeStyleSheetManager;
